"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

var _AccountCircle = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var drawerWidth = 240;

var styles = function styles(theme) {
  var _appBar;

  return {
    appBar: (_appBar = {
      background: theme.palette.common.white,
      color: theme.palette.secondary.contrastText,
      padding: '0 1.5rem',
      position: 'absolute',
      marginLeft: drawerWidth
    }, _defineProperty(_appBar, theme.breakpoints.up('md'), {
      width: "calc(100% - ".concat(drawerWidth, "px)")
    }), _defineProperty(_appBar, theme.breakpoints.down('sm'), {
      color: theme.palette.primary.contrastText,
      background: theme.palette.primary.main
    }), _appBar),
    grow: {
      flexGrow: 1
    },
    indicator: {
      height: '4px'
    },
    navIconHide: _defineProperty({}, theme.breakpoints.up('md'), {
      display: 'none'
    }),
    rightIcon: _defineProperty({}, theme.breakpoints.down('sm'), {
      color: theme.palette.secondary.main
    }),
    toolbar: {
      padding: 0
    }
  };
};

var MyAppBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MyAppBar, _React$Component);

  function MyAppBar(props) {
    var _this;

    _classCallCheck(this, MyAppBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MyAppBar).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (tab) {
      _this.setState({
        tab: tab
      });

      _this.props.handleTabClick(tab);
    });

    _this.state = {
      tab: 0
    };
    return _this;
  }

  _createClass(MyAppBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          logout = _this$props.logout,
          openDrawer = _this$props.openDrawer,
          tabs = _this$props.tabs,
          title = _this$props.title;
      return _react["default"].createElement(_AppBar["default"], {
        className: classes.appBar
      }, _react["default"].createElement(_Toolbar["default"], {
        classes: {
          root: classes.toolbar
        }
      }, _react["default"].createElement(_IconButton["default"], {
        color: "inherit",
        "aria-label": "Open drawer",
        onClick: openDrawer,
        className: classes.navIconHide
      }, _react["default"].createElement(_Menu["default"], {
        color: "secondary"
      })), _react["default"].createElement(_Typography["default"], {
        variant: "subtitle1",
        color: "inherit",
        className: classes.grow
      }, title), _react["default"].createElement(_IconButton["default"], {
        id: "logoutButton",
        color: "primary",
        onClick: logout
      }, _react["default"].createElement(_AccountCircle["default"], {
        className: classes.rightIcon
      }))), tabs ? _react["default"].createElement(_Tabs["default"], {
        value: this.state.tab,
        "aria-label": "simple tabs example",
        classes: {
          indicator: classes.indicator
        }
      }, tabs.map(function (tabLabel, i) {
        return _react["default"].createElement(_Tab["default"], {
          key: i,
          label: tabLabel,
          onClick: function onClick() {
            return _this2.handleTabClick(i);
          }
        });
      })) : null);
    }
  }]);

  return MyAppBar;
}(_react["default"].Component);

var _default = (0, _styles.withStyles)(styles, {
  withTheme: true
})(MyAppBar);

exports["default"] = _default;